import styled from 'styled-components';

import { Avatar } from '@hivebrite/design-system/Avatar';
import { Box } from '@hivebrite/design-system/Box';
import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import type { NotifyUser } from '../types';

interface UserChipProps {
  user: NotifyUser;
  onRemove: (user: NotifyUser) => void;
}

const UserChip = ({ user, onRemove }: UserChipProps) => (
  <UserChipWrapper>
    {user.avatar ? <Avatar size="24px" src={user.avatar} /> : null}
    <Box ml={1} color="white" fontWeight={1}>
      {user.name}
    </Box>
    <Box ml={2} mr={1} mt="1px">
      <UserChipButton
        aria-label={s__('NotifyPeople|Remove %{userName} from the list').i__({
          userName: user.name,
        })}
        data-testid="user-chip-button"
        onClick={() => onRemove(user)}
      >
        <FontAwesomeIcon iconName="xmark" height="14px" />
      </UserChipButton>
    </Box>
  </UserChipWrapper>
);

export default UserChip;

const UserChipWrapper = styled(Box).attrs({
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: 'primary',
  color: 'white',
  p: '6px',
  pl: 2,
  m: 1,
})`
  border-radius: 5px;
`;

const UserChipButton = styled.button`
  appearance: none;
  background-color: transparent;
  border: 0;
  color: white;
  cursor: pointer;
  padding: 0;

  &:focus {
    outline: 2px white solid;
  }
`;
